import { createStore } from 'easy-peasy'
import { StoreModel } from './store.interface'
import { storeModel } from './store.model'

const store = createStore<StoreModel>(storeModel)

export { store }
